var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "service-card", on: { click: _vm.openModal } },
    [
      _c("figure", {
        staticClass: "service-card__icon",
        domProps: { innerHTML: _vm._s(_vm.data.icon) },
      }),
      _c("div", { staticClass: "service-card__line" }),
      _c("h4", [_vm._v(_vm._s(_vm.data.title))]),
      _c("span", { staticClass: "service-card__subtitle" }, [
        _vm._v(_vm._s(_vm.data.description)),
      ]),
      _c(
        "span",
        { staticClass: "service-card__route" },
        [
          _vm._v("Подробнее\n    "),
          _c("IconComponent", { attrs: { name: "arrow-right" } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }